

























import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class ConfirmModal extends Vue {
  @Prop({ default: false })
  private display: boolean;

  @Prop()
  private modalTitle: string;

  @Prop()
  private modalText: string;

  @Prop({ default: 'OK' })
  private okButtonLabel: string;

  @Prop({ default: 'キャンセル' })
  private cancelButtonLabel: string;

  @Prop()
  private cancelClick: any;

  @Prop()
  private okClick: any;
}
